document.addEventListener("DOMContentLoaded", function(){

    const compareButtons = document.querySelectorAll(".a3n-compare-btn");

    let compareProducts = JSON.parse(localStorage.getItem("a3nCompare")) || [];


    compareButtons.forEach(button => {

        button.addEventListener("click", function(){


            let product = {

                id: this.dataset.productId,
                title: this.dataset.productTitle,
                url: this.dataset.productUrl,
                image: this.dataset.productImage,

                price: this.dataset.productPrice,
                processor: this.dataset.processor,
                ram: this.dataset.ram,
                storage: this.dataset.storage,
                os: this.dataset.os

            };


            let exists = compareProducts.find(
                item => item.id == product.id
            );


            if(exists){


                compareProducts = compareProducts.filter(
                    item => item.id != product.id
                );


                this.innerHTML = "Compare";


            }else{


                if(compareProducts.length >= 3){

                    alert("You can compare maximum 3 products");

                    return;

                }


                compareProducts.push(product);


                this.innerHTML = "Remove ×";


            }


            localStorage.setItem(
                "a3nCompare",
                JSON.stringify(compareProducts)
            );


           if(!window.location.pathname.includes("compare-products")){
                showCompareBar();
            }


        });


    });



    function showCompareBar(){


        let oldBar = document.querySelector(".a3n-compare-bar");


        if(oldBar){

            oldBar.remove();

        }



        if(compareProducts.length == 0){

            return;

        }



        let bar = document.createElement("div");

        bar.className = "a3n-compare-bar";



        let productsHTML = "";



        compareProducts.forEach(product=>{


            productsHTML += `

            <div class="a3n-mini-product">


                <img src="${product.image}">


                <span>
                ${product.title}
                </span>


                <button 
                class="a3n-remove-product"
                data-id="${product.id}">
                ×
                </button>


            </div>


            `;


        });



        bar.innerHTML = `


        <div class="a3n-selected-products">

            ${productsHTML}

        </div>



        <div class="a3n-compare-actions">


            <span>
            ${compareProducts.length} Products Selected
            </span>



            <button class="a3n-go-compare">

            Compare Now

            </button>



            <button class="a3n-clear-compare">

            Clear

            </button>


        </div>


        `;



        document.body.appendChild(bar);




        document.querySelector(".a3n-go-compare")
        .onclick=function(){


            window.location.href="/pages/compare-products?compare=true";


        };




        document.querySelectorAll(".a3n-remove-product")
        .forEach(btn=>{


            btn.onclick=function(){


                let id=this.dataset.id;



                compareProducts = compareProducts.filter(
                    item => item.id != id
                );



                localStorage.setItem(
                    "a3nCompare",
                    JSON.stringify(compareProducts)
                );



                showCompareBar();


            };


        });





        document.querySelector(".a3n-clear-compare")
        .onclick=function(){


            localStorage.removeItem("a3nCompare");


            compareProducts=[];


            showCompareBar();


        };



    }



    if(!window.location.pathname.includes("compare-products")){
    showCompareBar();
}



});